<template>
  <main class="app-content">
    <div class="app-title">
      <h1><i class="fa fa-money"></i> {{ $t('commissionReport') }}</h1>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tab">
          <b-tab>
            <template #title>
              KPI
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('callingFee') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('commission') }}
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <kpi-revenue v-if="tab === 0"></kpi-revenue>
    <call-fee-commission v-if="tab === 1"></call-fee-commission>
  </main>
</template>

<script>
import KpiRevenue from "@/views/report/commission/KpiRevenue";
import CallFeeCommission from "@/views/report/commission/CallFeeCommission";

export default {
  components: { KpiRevenue, CallFeeCommission },
  data() {
    return {
      tab: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        commissionReport: 'Commission report',
        commission: 'Commission',
        callingFee: 'Calling fee',
      },
      vi: {
        commissionReport: 'Báo cáo hoa hồng',
        commission: 'Hoa hồng',
        callingFee: 'Cước gọi',
      }
    }
  }
}
</script>